import * as languages from '../enums/supported-languages'

/**
 * performs a lookup for an identical match
 * @param language
 */
let resolveId = (language) => {
  return languages.SUPPORTED_LANGUAGES.find(o => o.code === language).ID
}

/**
 * performs a lookup to find related languages
 * eg if 'en' is passed in then we need to return ENGLISH_UK (en-gb) & ENGLISH_US (en-us)
 * @param language
 */
let resolveRelatedIds = (language) => {
  let languageIds = []
  for (let lang of languages.SUPPORTED_LANGUAGES) {
    if (lang.code.includes('-')) {
      if (language === lang.code.substring(0, lang.code.indexOf('-'))) {
        languageIds.push(lang.ID)
      }
    } else {
      if (language === lang.code) {
        languageIds.push(lang.ID)
      }
    }
  }
  return languageIds
}

/**
 * called when a direct lookup has failed, checks for generic supported languages
 * @param language
 */
let resolveGenericIDs = (language) => {
  if (language.includes('-')) {
    language = language.substring(0, language.indexOf('-'))
    try {
      return resolveId(language)
    } catch (err) {
      return resolveRelatedIds(language)
    }
  } else {
    return resolveRelatedIds(language)
  }
}

/**
 * removes duplicate entries
 * @param languages
 */
let resolveDuplicates = (languages) => {
  return [...new Set(languages)]
}

/**
 * resolves the browser/system languages to our supported language id's
 * @returns array of language id's
 */
let resolve = () => {
  let languages = []
  let ids = []
  if (navigator.languages) {
    languages = navigator.languages
  } else {
    languages.push(navigator.language)
  }
  for (let language of languages) {
    try {
      ids.push(resolveId(language))
    } catch (err) {
      ids = ids.concat(resolveGenericIDs(language))
    }
  }
  return resolveDuplicates(ids)
}
export default {
  resolve
}
